import React, { createContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { fetchData } from "./fetchdata";

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [originalData, setOriginalData] = useState([]);
  const [supportList, setSupportList] = useState([]);
  const [advSearchList, setAdvSearchList] = useState([]);
  const [serviceList, setServiceList] = useState([]);

  const location = useLocation();
  const prevCoreParamsRef = useRef("");

  // Extract city, state, etc. from the query string
  const queryParams = new URLSearchParams(location.search);
  const city = queryParams.get("city");
  const state = queryParams.get("state");
  const lat = queryParams.get("lat");
  const lng = queryParams.get("lng");
  const radius = queryParams.get("radius") || "25";
  const service = queryParams.get("service");
  const zip = queryParams.get("zip");

  useEffect(() => {
    const coreParams = `${city || ""}-${state || ""}-${lat || ""}-${lng || ""}-${radius || ""}-${service || ""}-${zip || ""}`;

    // If coreParams differ from the last known value, re-fetch
    if (prevCoreParamsRef.current !== coreParams) {
      prevCoreParamsRef.current = coreParams;
      setLoading(true);
      fetchData({ city, state, lat, lng, radius, service, zip }, setLoading, setOriginalData, setSupportList, setAdvSearchList, setServiceList);
    }
    // If coreParams didn't change, do nothing — meaning no loading triggered on filter changes
  }, [location.search]);

  return <SearchContext.Provider value={{ loading, originalData, supportList, city, state, radius, advSearchList, serviceList, service, lat, lng }}>{children}</SearchContext.Provider>;
};
